import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import FormFields from "../../atoms/FormFields";
import Buttons from "../../atoms/Buttons";
import CustomDropdownMenu from "../../atoms/CustomDropdownMenu";
import "./chooseflexiaccessincomemodal.scss";
import { Link } from "react-router-dom";

const ChooseFlexiAccessIncomeModal = (props) => {
  const [amount, setAmount] = useState(
    props.directFromManage
      ? props?.flexiAcessCurrentIncome
        ? props?.flexiAcessCurrentIncome
        : 0
      : 0,
  );
  const [period, setPeriod] = useState(
    props.directFromManage
      ? props?.flexiAccessDuration
        ? props?.flexiAccessDuration
        : "Monthly"
      : "Monthly",
  );
  const [isError, setIsError] = useState(false);

  const periodOptions = [
    {
      option: "Monthly",
      value: "Monthly",
    },
    {
      option: "Quarterly",
      value: "Quarterly",
    },
    {
      option: "Half yearly",
      value: "Half yearly",
    },
    {
      option: "Annually",
      value: "Annually",
    },
  ];

  const changePeriodValue = (value) => {
    setPeriod(value);
  };

  const amountChange = (e) => {
    const value = e.target.value;

    let income = value.trimStart().replace(/\s+/g, "").replace(/£/g, "") || "0";
    if (income !== "0") {
      income = income.replace(/^0+(?!\.)/, "");
    }
    const regex = /^\d+(\.\d{0,2})?$/;
    if (regex.test(income) || income === "") {
      if (Number(income) <= props?.currentValue) {
        setIsError(false);
      } else {
        setIsError(true);
      }
    } else {
      setIsError(true);
    }
    setAmount(income);
  };

  const handleChooseFlexiAccessIncome = () => {
    if (amount > 0) {
      props.handleFlexiAccessContinue(amount, period);
    } else {
      setIsError(true);
    }
  };

  return (
    <div className="parent-choose-flexi-access">
      <Row className="mb-3">
        <Col>
          <div className="cfa-small-close">
            <Link to="">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row className="cfa-title mb-3">
        <Col>
          <div>{props.modalTitle}</div>
        </Col>
      </Row>
      <Row className="cfa-sub-title mb-3">
        <Col>
          <div>
            As part of your flexi-access strategy you can decide what income you
            would like to drawdown and how often. Press Continue to view an
            illustration of how long your flexi-access plan could last.
          </div>
        </Col>
      </Row>
      <Row className="cfa-review mb-3">
        <Col>
          <div>I would like to receive:</div>
        </Col>
      </Row>
      <Row className="mb-5">
        <Col xl={5} lg={5} md={5}>
          <FormFields
            value={`£${amount}`}
            variant={isError ? "form-field-plain-error" : "form-field-plain"}
            // size="lg"
            plainTextField={true}
            changeHandler={amountChange}
          />
        </Col>
        <Col xl={5} lg={5} md={5}>
          <CustomDropdownMenu
            dropDownData={periodOptions}
            selectedItem={changePeriodValue}
            defaultValue={period}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xl={12} lg={12} md={12}>
          <div className="cfa-button">
            {props.isCancel ? (
              <div className="cfa-cancel-button">
                <Buttons
                  name="Cancel"
                  className="secondary"
                  variantname="icon-sixteen-px"
                  handleClick={props.handleCloseButton}
                ></Buttons>
              </div>
            ) : (
              <div className="cfa-cancel-button">
                <Buttons
                  name="Proceed without income"
                  className="secondary"
                  variantname="icon-sixteen-px"
                  handleClick={() => props.handleProceedWithoutIncome(0, "")}
                ></Buttons>
              </div>
            )}
            <div>
              <Buttons
                name="Continue"
                className="primary"
                variantname="icon-sixteen-px"
                handleClick={handleChooseFlexiAccessIncome}
                disabled={
                  props.directFromManage
                    ? amount === "" ||
                      isError ||
                      (parseInt(props?.flexiAcessCurrentIncome) ===
                        parseInt(amount) &&
                        props?.flexiAccessDuration === period)
                    : parseInt(amount) === 0 || isError
                } //eslint-disable-line
              ></Buttons>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ChooseFlexiAccessIncomeModal;
